import "core-js";

import Vue from "vue";
import "flickity-fullscreen/fullscreen.css";
import "flickity-fullscreen";
import "leaflet/dist/leaflet.css";

// Import A11y (accessibility) Dialog for megamenu.
// See https://a11y-dialog.netlify.app/
import A11yDialog from 'a11y-dialog';

// Import Bootstrap JS components one by one to reduce bundle size.
// See https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap
import { Dropdown } from 'bootstrap';

import vueComponents from "./lib/vueComponents";
import drawer from "./lib/drawer";
//import headroom from "./lib/headroom";
import modal from "./lib/modal";
import googleMap from "./lib/googleMap";
import applicationReset from "./lib/applicationReset";
import InlineSvg from "./vue/components/InlineSvg";
import SiteHeaderMobile from "./vue/SiteHeaderMobile";
import StandaloneApartmentCard from "./vue/StandaloneApartmentCard";
import FavouritesDropdown from "./vue/FavouritesDropdown";
import SearchDropdown from "./vue/SearchDropdown";
import ApplicationRent from "./vue/ApplicationRent";
import ApplicationOwnerOccupancy from "./vue/ApplicationOwnerOccupancy";
import ApplicationRightOfOccupancy from "./vue/ApplicationRightOfOccupancy";
import ImageSlider from "./vue/ImageSlider";
import FavouriteToggle from "./vue/FavouriteToggle";
import ApartmentSearchFull from "./vue/ApartmentSearchFull";
import ApartmentSearchFullAllTypes from "./vue/ApartmentSearchFullAllTypes";
import StandaloneApartmentSearchForm from "./vue/StandaloneApartmentSearchForm";
import StandaloneApartmentSearchFormMinimal from "./vue/StandaloneApartmentSearchFormMinimal";
import PopupMap from "./vue/PopupMap";
// import Map from "./vue/Map";
import PopupVirtual from "./vue/PopupVirtual";
import ContactInfoSearch from "./vue/ContactInfoSearch";
import HousingLocalityApartments from "./vue/HousingLocalityApartments";
import HousingLocalityApartmentsAvailable from "./vue/HousingLocalityApartmentsAvailable";
import RelatedItems from "./vue/RelatedItems";
import HousingLocalityGroup from "./vue/HousingLocalityGroup";
import CampaignItemsList from "./vue/CampaignItemsList.vue";
import HousingLocalitySliderCard from "./vue/HousingLocalitySliderCard";
import ApplicationActivityTimer from "./vue/ApplicationActivityTimer";
import PickPostCard from "./vue/PickPostCard";
import Gallery from "./vue/Gallery";

import 'leaflet/dist/leaflet.css';

window.initGoogleMap = googleMap.init;

// Add global Vue components
Vue.component("InlineSvg", InlineSvg);

// Init Vue root components
vueComponents.init({
  SiteHeaderMobile,
  StandaloneApartmentCard,
  FavouritesDropdown,
  SearchDropdown,
  ApplicationRent,
  ApplicationRightOfOccupancy,
  ApplicationOwnerOccupancy,
  ImageSlider,
  FavouriteToggle,
  ApartmentSearchFull,
  ApartmentSearchFullAllTypes,
  StandaloneApartmentSearchForm,
  StandaloneApartmentSearchFormMinimal,
  PopupMap,
  // Map, // Simple map.
  PopupVirtual,
  ContactInfoSearch,
  HousingLocalityApartments,
  HousingLocalityApartmentsAvailable,
  RelatedItems,
  HousingLocalityGroup,
  CampaignItemsList,
  HousingLocalitySliderCard,
  ApplicationActivityTimer,
  PickPostCard,
  // Gallery
  Gallery
});

drawer.init();
//headroom.init();
modal.init();
applicationReset.init();

// Initialize A11y Dialog for megamenu.
const container = document.querySelector('#avain-megamenu');
const dialog = new A11yDialog(container);

// Prevent scrolling when megamenu is open.
// See https://a11y-dialog.netlify.app/advanced/scroll-lock
dialog
  .on('show', () => (document.documentElement.style.overflowY = 'hidden'))
  .on('hide', () => (document.documentElement.style.overflowY = ''))
